import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, IconButton } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ConfirmationDialog from 'src/components/ConfirmationDialog';
import HttpServices from 'src/services/httpService';
import { imageModeuleUrl, postsModuleURL } from 'src/services/urlService';
import { CommonHelper } from 'src/utils/commonHelper';
import { useToaster } from 'src/utils/toaster/toasterContext';
import DraftPostActionPopup from './PostGridActionPopup.component';
import { useTranslation } from 'react-i18next';

const DraftPostGridAction = ({ draftList, handleReCallDraft,isOrgEvent }) => {
    const { t: translate } = useTranslation();
  const navigate = useNavigate();
  const { showToast } = useToaster();
  const [selectedPopOverPost, setPopOverPost] = useState(null);
  const [popoverElement, setPopoverElement] = useState(null);
  const [loading, setLoading] = useState(false);
  const [confirmationDialogue, setConfirmationDialogue] = useState(null);

  const handleOpenMenu = (event, draftList) => {
    setPopOverPost(draftList);
    setPopoverElement(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setPopOverPost(null);
    setPopoverElement(null);
  };

  const closeConfirmationDialogue = () => {
    setConfirmationDialogue(null);
  };

  const failureCallback = (message) => {
    message && showToast(message, 'e');
    handleCloseMenu();
    setLoading(false);
    closeConfirmationDialogue();
  };
  const handleUploadDraft = () => {
    setLoading(true);
    CommonHelper.CommonNewPostStruct(isOrgEvent,draftList.id, newPostSucessCallback, failureCallback);
  };
  const fetchMediaMetaData = (data) => {
    let mediaBody = {
      media_urls: data?.media_url.split(','),
    };
    let postProps = {
      url: imageModeuleUrl.fetchMediaMetadata,
      body: mediaBody,
      successCallback: (imageData, message) => {
        fetchMediaSuccessCallback(imageData, message, data);
      },
      failureCallback: failureCallback,
    };
    HttpServices.Post(postProps);
  };
  const fetchMediaSuccessCallback = (imageData, mesaage, data) => {
    uploadDataToPost(data, imageData ? imageData.media_datas : []);
  };
  const newPostSucessCallback = (data) => {
    if (data.media_url && data.media_url.length > 0) fetchMediaMetaData(data);
    else uploadDataToPost(data);
  };

  const uploadDataToPost = (data, imageData = []) => {
    setLoading(false);
    const newPostData = CommonHelper.CommonNewPostAddMediaAllService(data, imageData);
    navigate('/new-post', { state: { data: newPostData } });
  };

  const handleDeleteDraft = () => {
    handleCloseMenu();
    setConfirmationDialogue({
      isOpen: true,
      title: translate("common.confirm_deletion"),
      message: `${translate("draft.delete_this_draft")}?`,
      submitFunction: confirmDeletePost,
    });
  };

  const confirmDeletePost = () => {
    let postProps = {
      url: isOrgEvent ? postsModuleURL.orgDeleteDraft + draftList.id : postsModuleURL.deleteDraft + draftList.id,
      successCallback: deleteSuccessCallback,
      failureCallback,
    };
    HttpServices.Post(postProps);
    closeConfirmationDialogue();
  };

  const deleteSuccessCallback = (data, message) => {
    message && showToast(message);
    handleCloseMenu();
    closeConfirmationDialogue();
    handleReCallDraft();
  };

  const postActionProps = {
    loading,
    popoverElement: popoverElement,
    handleCloseMenu,
    handleUploadDraft,
    handleDeleteDraft,
    selectedPopOverPost: selectedPopOverPost,
  };

  return (
    <>
      <Box display="flex" alignItems="right">
        <IconButton
          size="large"
          color="inherit"
          onClick={(e) => {
            handleOpenMenu(e, draftList);
          }}
          sx={{ padding: '6px', marginRight: '2px' }}
        >
          <MoreVertIcon />
        </IconButton>
        <DraftPostActionPopup {...postActionProps} />
      </Box>
      {confirmationDialogue && (
        <ConfirmationDialog
          open={confirmationDialogue.isOpen}
          onClose={() => closeConfirmationDialogue()}
          onConfirm={confirmationDialogue.submitFunction}
          title={confirmationDialogue.title}
          message={confirmationDialogue.message}
        />
      )}
    </>
  );
};

export default DraftPostGridAction;
